import * as React from "react"
import { Link } from "gatsby"

const Hero = () => {
  return (
    <>
      <div className={"relative max-w-5xl mx-auto px-6 sm:px-8 z-10"}>
        <div className={"pt-40 pb-32 lg:py-24"}>
          <h1
            className={
              "text-4xl lg:text-6xl text-left lg:text-center text-white mb-6 uppercase leading-[2.2rem] lg:leading-[2.75rem]"
            }
          >
            Bespoke yacht brokerage and charters
          </h1>
          <p
            className={
              "text-xl lg:text-2xl text-left lg:text-center text-white mb-10 leading-tight lg:px-14"
            }
          >
            With over 15 years of expertise in facilitating successful yacht
            sales, we have established ourselves as the go-to yacht brokerage
            for discerning yacht enthusiasts.
          </p>
          <div className={"grid md:grid-cols-2 gap-2"}>
            <div>
              <Link
                className={
                  "h-full flex flex-row items-center justify-between py-8 px-8 shadow-2xl border-4 border-white border-opacity-20 bg-navy-900 bg-opacity-70 hover:border-blue hover:bg-opacity-100 transition duration-500 ease-in-out"
                }
                to={"/buyers"}
              >
                <div>
                  <h2 className={"text-white text-xl mb-0"}>Buy with Luxe</h2>
                  <p className={"text-white text-xl text-pretty"}>
                    Buy with confidence the Luxe way
                  </p>
                </div>
                <span
                  className={`ml-2 transition duration-500 ease-in-out text-blue group-hover:text-blue-700`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={"2"}
                    className={`w-8 h-8 stroke-current`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                    />
                  </svg>
                </span>
              </Link>
            </div>
            <div>
              <Link
                className={
                  "h-full flex flex-row items-center justify-between py-8 px-8 shadow-2xl border-4 border-white border-opacity-20 bg-navy-900 bg-opacity-70 hover:border-blue hover:bg-opacity-100 transition duration-500 ease-in-out"
                }
                to={"/sellers"}
              >
                <div>
                  <h2 className={"text-white text-xl mb-0"}>Sell with Luxe</h2>
                  <p className={"text-white text-xl text-pretty"}>
                    Sell from the comfort of your own berth
                  </p>
                </div>
                <span
                  className={`ml-2 transition duration-500 ease-in-out text-blue group-hover:text-blue-700`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={"2"}
                    className={`w-8 h-8 stroke-current`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                    />
                  </svg>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hero
